import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export type TIsExpiredDateType = 'ok' | 'expired' | 'soon' | 'between';

export const isExpiredDate = (startDate: string | Dayjs, endDate: string | Dayjs): TIsExpiredDateType => {
  const start = dayjs(startDate);
  const end = dayjs(endDate).add(24, 'hour');
  const now = dayjs();

  const diffStart = start.diff(now, 'hour');
  const diffEnd = end.diff(now, 'hour');

  let result: TIsExpiredDateType;

  if (diffStart <= 24 && diffStart >= 0 && diffEnd >= 0) {
    result = 'soon';
  } else if (diffStart <= 0 && diffEnd >= 0) {
    result = 'between';
  } else if (diffStart <= 0 && diffEnd <= 0) {
    result = 'expired';
  } else {
    result = 'ok';
  }

  return result;
};
